module.exports = __webpack_public_path__ + "img/multipleAdd.png?c57e173a721ca17971de8db315408ae2";